import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import CardPreview from "../../../components/TutorialsItem/cardpreview";
import images from "../../../images";
import Header from "../../../components/Header/Header";
import achievementsData from "../../../contanst/achievementList.json";
import { useTranslation } from "react-i18next";

const AchievementDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const achievement = achievementsData.find(
    (achievement) => achievement.id === parseInt(id)
  );

  if (!achievement)
    return (
      <p className="text-red-500"> {t("achievements.achievementNotFound")}</p>
    );

  const placeholderImages = [images.trophyIcon, images.ImageMain];

  return (
    <div className="flex flex-col items-center">
      <div className="sticky top-0 left-0 w-full z-50 bg-[#253FF6]">
        <Header
          backIcon={images.BackIcon}
          onBackClick={() => navigate(-1)}
          title={t("achievements.achievementDetail")}
          textColor="text-white"
        />
      </div>

      <div className="p-4 w-full flex flex-col items-center">
        <CardPreview
          title={achievement.title}
          description={achievement.detail.fullDescription}
          images={placeholderImages}
        />

        <div className="mt-6 text-left w-full max-w-sm">
          <div className="border border-gray-100 p-3 rounded-xl">
            <h3 className="text-base font-semibold text-blue-600">
              {t("achievements.titleInAchievementDetail")}
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              {achievement.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementDetail;
